/**
 * This ugly controller got too much dependency on UI and jQuery. This should be simple be
 * replaced by ReactJS or any kind of framework that supports data binding. Don't blame me
 * for the retarded code.
 * @author Ka Wing Chin <kawing.chin@takeaway.com>
 * @class Takeaway.BasketController
 */

/* global jQuery */

import Basket from '../models/basket'
import DOM from '../lib/dom'
import ENUM from '../lib/enums'
import moment from 'moment'
import PaymentMethod from '../models/payment-method'
import Product from '../models/product'
import ProductSize from '../models/product-size'
import SideDish from '../models/side-dish'
import UI from './ui'
import Utils from '../lib/utils'
import Voucher from '../models/voucher'
import '../components/container.scss'

// TODO Remove $ dependency, note that it's NOT jQuery's $
const $ = (selector, container = document) => container.querySelector(selector)

export default class BasketController {
  /**
   * Constructor
   * @param products
   * @param {ENUM.DeliveryMethod.Type} deliveryType
   * @param pageDOM
   * @param {Restaurant} restaurant
   * @param serverDateTime
   * @param showToastFunction
   */
  constructor ({
    deliveryType,
    mode,
    page,
    products,
    restaurant,
    serverDateTime,
    showToastFunction
  } = {}) {
    this.mode = mode
    this.products = products
    this.page = page
    this.restaurant = restaurant
    this.serverDateTime = serverDateTime
    this.showToastFunction = showToastFunction

    console.log('%c BasketController() UI.renderContainer() ', 'background: #008000; color: #fff')
    UI.renderContainer({ i18n: restaurant.translations, deliveryType: deliveryType })

    this.basket = new Basket(this.restaurant, deliveryType, this.serverDateTime)
    console.log('basketProducts', this.basket.basketProducts)
  }

  /**
   * The selected product for adding comment.
   * @private
   */
  selectedProductCommentId = null
  /**
   * @property {string} selectedProductComment The commment of the selected product comment.
   * It is used for temporary caching. Why? When you have a comment open and you change the basket.
   * The UI will be refreshed because of jQuery (shit library). This variable will remember what the text was.
   */
  selectedProductComment = null

  showRestaurantIsClosed () {
    const { name, translations, deliveryAreaId } = this.restaurant

    let message = ''

    switch (this.mode) {
      case ENUM.MODE.RESTAURANT:
        message = `${name} ${translations.restaurantClosed2}.`
        break
      case ENUM.MODE.COUNTRY:
      default:
        message = `${name} ${translations.restaurantClosed2} <a href="${deliveryAreaId}">${translations.restaurantClosed3}</a>.`
        break
    }

    this.showToastFunction(message)
  }

  /**
   * check if already displayed consent for certain Age verification
   * @param minAge
   * @returns {boolean}
   */
  hasProductsForMinAge(minAge) {
    let minAgeValue = this.basket.getMinAgeConsentValue()

    if (minAgeValue === null) {
      return false
    }
    return minAgeValue >= minAge
  }

  /**
   * action taken after confirm the age consent
   * @param productId
   * @param minAge
   * @param isSideDish
   * @returns {boolean}
   */
  acceptAgeVerificationConsent(productId, minAge, isSideDish = false) {
    window.ageConsent('close');
    if(isSideDish === true) {
      return window.addSideDishBasket(productId, minAge)
    }
    return window.addBasket(productId, minAge)
  }

  /**
   * show age consent popup
   * @param id
   * @param minAge
   * @param isSideDish
   */
  showAgeVerificationConsentMessage(id, minAge, isSideDish = false) {
    // TODO :: pull out the inline css into its own css file.
    const template = `
        <div>
            <div class="popupheader">
            <strong>${this.restaurant.translations.AGE_VERIFICATION_HEADER}</strong>
            </div>
            <div class="popupcontent">
                <p>${this.restaurant.translations.AGE_VERIFICATION_BODY_MAIN}</p>
                <p>
                   <strong>${this.restaurant.translations.AGE_VERIFICATION_BODY_AGE.replace('{max_age_restriction_in_basket}', minAge)}</strong>
                </p>
            </div>
            <div class="sidedish-footer">
                <button class="cartbutton-button cartbutton-button-sidedishes add-btn-icon"
                onclick="basket.acceptAgeVerificationConsent('${id}', ${minAge}, ${isSideDish})">
                ${this.restaurant.translations.AGE_VERIFICATION_YES}
                </button>
                <button onclick="window.ageConsent('close')"
                style="background-color: gray"
                class="cartbutton-button cartbutton-button-sidedishes add-btn-icon">
                ${this.restaurant.translations.AGE_VERIFICATION_NO}
               </button>
            </div>
        </div>`
    window.ageConsent('init');
    jQuery('#ageRestriction').html(template)
  }

  addProduct (id, minAge = null) {
    const product = this.getProduct(id)
    if (product === null) {
      console.log('failed to add product, trying to cheat by calling the method?')
      return
    }

    const result = this.basket.addProduct(product, minAge)
    switch (result) {
      case Basket.PRODUCT.SUCCESS:
        this.updateUI()
        break
      case Basket.PRODUCT.RESTAURANT_CLOSED:
        this.showRestaurantIsClosed()
        break
      case Basket.PRODUCT.CATEGORY_UNAVAILABLE:
        var category = this.restaurant.getCategoryById(product.categoryId)
        var sb = new Utils.StringBuilder()
        sb.append(this.restaurant.translations.categoryClosed1)
          .append(' ')
          .append(category.currentOrderTime.endTime.format('HH:mm'))
          .append(this.restaurant.translations.categoryClosed2)
        this.showToastFunction(sb.toString())
        break
      default:
        console.log('Unknown error adding product')
        break
    }
  }

  removeProduct (event, id) {
    event.stopPropagation()
    this.basket.removeProduct(id)
    if (id === this.selectedProductCommentId) {
      this.selectedProductCommentId = null
      this.selectedProductComment = null
    }
    // Remove voucher. This is bad code to handle it like this. Shitty global.
    if (this.basket.totalProducts === 0) {
      this.removeVoucher()
    }
    this.updateUI()
  }

  increaseProduct (event, id) {
    event.stopPropagation()
    this.basket.increaseProduct(id)
    this.updateUI()
  }

  decreaseProduct (event, id) {
    event.stopPropagation()
    if (this.basket.decreaseProduct(id)) {
      if (id === this.selectedProductCommentId) {
        this.selectedProductCommentId = null
        this.selectedProductComment = null
      }
      // Remove voucher. This is bad code to handle it like this. Shitty global.
      if (this.basket.totalProducts === 0) {
        this.removeVoucher()
      }
    }
    this.updateUI()
  }

  /**
   * @param event
   * @param id
   * @param {boolean} skip Skip the validation and get the comment from the local variable instead of the local storage.
   */
  openProductComment (event, id, skip) {
    event.stopPropagation()
    if (!skip) {
      if (this.selectedProductCommentId === id) {
        this.closeProductComment(event, id, true)
        return
      } else if (this.selectedProductCommentId !== null) {
        this.closeProductComment(event, this.selectedProductCommentId, true)
      }
    }

    // close other opened product comment.
    jQuery('.cart-row.commentinput').hide()

    this.selectedProductCommentId = id
    const comment = skip
      ? this.selectedProductComment
      : this.basket.getComment(id)
    this.selectedProductComment = comment
    const commentInput = jQuery('#commentinput-' + id)

    // cross browser solution to put the mouse cursor at the end.
    commentInput.show()
    commentInput.find('textarea').focus()
    if (comment) {
      commentInput.find('textarea').val('')
      commentInput.find('textarea').val(comment)
    }
  }

  closeProductComment (event, id, save) {
    // Ugly check, becasuse of UtilityBar.js or split the method in a handler and UI logic
    if (id === null) {
      return
    }

    if (event !== null) {
      event.stopPropagation()
    }

    var commentInput = jQuery('#commentinput-' + id)
    if (save) {
      var comment = commentInput.find('textarea').val().replace(/<(?:.|\n)*?>/gm, '')
      this.basket.addComment(id, comment)
      this.selectedProductCommentId = null
      this.updateBasketUI()
    } else {
      commentInput.find('textarea').val('')
      commentInput.hide()
      this.selectedProductCommentId = null
    }
  }

  deleteProductComment (event, id) {
    event.stopPropagation()
    var commentInput = jQuery('#commentinput-' + id)
    commentInput.find('textarea').val('')
    this.basket.addComment(id, '')
    this.selectedProductCommentId = null
    this.selectedProductComment = null
    this.updateBasketUI()
  }

  /**
   * It only set the text in a cache. A bit cheaty, but see doc about selectedProductComment
   */
  addProductComment (event, id) {
    var commentInput = jQuery('#commentinput-' + id)
    var comment = commentInput.find('textarea').val()
    this.selectedProductComment = comment
  }

  /**
   * Get the delivery type that is set
   * @return {ENUM.DeliveryMethod.Type} which is an int.
   */
  getDeliveryMethod () {
    return this.basket.deliveryType
  }

  /**
   * Switch delivery type.
   * @param {ENUM.DeliveryMethod.Type} deliveryType ENUM.DeliveryMethod.Type
   */
  switchDeliveryType (deliveryType, force) {
    return this.basket.switchDeliveryType(deliveryType, force)
  }

  getBasketJson () {
    return this.basket.getBasketJson()
  }

  /**
   * Validate the selected delivery or pickup time. If there is an invalid category, only the first one will be returned.
   * @param {String} deliveryTimeString The time the user selected.
   */
  validateDeliveryTime (deliveryTimeString) {
    jQuery('#deliverytime-notification').text('')
    jQuery('#deliverytime-notification').addClass('hidden')
    let deliveryTime
    if (deliveryTimeString === 'asap') {
      deliveryTime = this.serverDateTime.time
    } else {
      deliveryTime = Utils.timeToToday(moment(deliveryTimeString, 'HH:mm'), this.serverDateTime.time)
    }

    let obj = this.basket.validateDeliveryTime(deliveryTime)
    if (obj === null) {
      return
    }

    let translations = this.restaurant.translations
    // console.log(obj.category)
    // var category = obj.category.orderTimes.filter(function (x) {
    //   return x.weekDay === this.serverDateTime.weekDay
    // })
    // console.log(category)

    var sb = new Utils.StringBuilder()
    sb.append(translations.timedProduct1)
      .append(' \'')
      .append(obj.product.productName)
      .append('\' ')
      .append(translations.timedProduct2)
      .append(' ')
      .append(obj.category.currentOrderTime.startTime.format('HH:mm'))
      .append(' ')
      .append(translations.timedProduct3)
      .append(' ')
      .append(obj.category.currentOrderTime.endTime.format('HH:mm'))
      .append(translations.timedProduct4)
      .append(' ')
      .append('<a href=\'/' + this.restaurant.url + '\'>')
      .append(translations.timedProduct5)
      .append('</a>')
      .append(' ')
      .append(translations.timedProduct6)

    DOM.html($('#deliverytime-notification'), sb.toString())
    jQuery('#deliverytime-notification').removeClass('hidden')
  }

  proceedCheckout () {
    if (this.basket.isCheckoutAllowed) {
      document.location = this.restaurant.orderUrl
    }
  }

  updateBasketAfterValidation (data) {
    // Business logic for updating and removing products.
    this.basket.updateBasketAfterValidation(data)
    console.log('updateBasketAfterValidation')
    this.updateUI()
  }

  /**
   * Products will be send to the server for validation.
   * Unused.
   */
  validateBasket (callback) {
    if (this.basket.deliveryType === ENUM.DeliveryMethod.Type.Delivery) {
      if (this.restaurant.deliveryAreaId === undefined) {
        console.log('postcode is missing')
        if (callback !== undefined && callback !== null) {
          callback(false)
        }
        return false
      }
    }

    if (!this.basket.isCheckoutAllowed || this.basket.isValidateBasketByServer) {
      if (callback !== undefined && callback !== null) {
        callback(false)
      }
      return false
    }

    this.basket.validateBasketByServer(function (result) {
      console.log(result)
      if (result.productMismatch) {
        for (let x in result.productMismatches) {
          var productMismatch = result.productMismatches[x]
          this.parseProductMismatch(productMismatch)
        }

        // for (let x in result.productMismatches) {
        //   var productMismatch = result.productMismatches[x]
        //   jQuery('#mismatch-' + productMismatch.uniqueId).show()
        // }
      }

      if (result.productMissing) {
        let sb = new Utils.StringBuilder()
        var i = result.productMissings.length
        while (i--) {
          var productMissingId = result.productMissings[i]
          var productMissing = this.basket.basketProducts.filter(function (x) {
            return x.uniqueId === productMissingId
          })[0]

          if (productMissing === undefined) {
            continue
          }

          sb.append(productMissing.productName)
            .append('<br />')

          if (productMissing.size !== null) {
            var sideDishesUI = []
            if (productMissing.productName !== productMissing.size.sizeName) {
              sideDishesUI.push(productMissing.size.sizeName)
            }

            if (productMissing.size.sideDishes.length > 0) {
              sideDishesUI.push(this.generateSideDishString(productMissing.size.sideDishes))
            }
            sb.append(sideDishesUI.join(', '))
              .append('<br />')
          }
          sb.append('<br />')
          this.basket.removeProduct(productMissing.uniqueId)
        }
      }

      // Last check if the basket is still complete.
      var count = 0
      for (let i in result.productExistingIds) {
        var basketProduct = this.basket.basketProducts.filter(function (x) {
          if (x.uniqueId === result.productExistingIds[i]) {
            count++
          }
        }.bind(this))
      }
      if (count !== result.productExistingIds.length) {
        throw new Error('Something went wrong with the validation')
      }

      this.basket.calculateTotalPrice()
      this.basket.saveBasket()
      this.updateUI()

      var endResult = {
        isValid: !result.productMismatch && !result.productMissing,
        isMismatch: result.productMismatch,
        isMissing: result.productMissing,
        errorMessage: result.message,
        redirectUrl: result.url
      }

      if (callback !== undefined && callback !== null) {
        callback(endResult)
      }
    }.bind(this))
  }

  // @delete
  parseProductMismatch (productMismatch) {
    var basketProduct = this.basket.basketProducts.filter(function (x) {
      return x.uniqueId === productMismatch.uniqueId
    })[0]

    if (basketProduct === undefined) {
      return
    }

    // The data doesn't distinct product and size.
    if (basketProduct.size !== null) {
      basketProduct.size.price = productMismatch.singlePrice
      basketProduct.size.pricePickup = productMismatch.singlePricePickup
      basketProduct.deliveryType = parseInt(productMismatch.deliveryType)
      basketProduct.ignoreMinimumOrderValue = productMismatch.ignoreMinimumOrderValue
    } else {
      basketProduct.basePrice = productMismatch.singlePrice
      basketProduct.basePricePickup = productMismatch.singlePricePickup
      basketProduct.deliveryType = parseInt(productMismatch.deliveryType)
      basketProduct.ignoreMinimumOrderValue = productMismatch.ignoreMinimumOrderValue
    }

    for (let x in productMismatch.sideDishes) {
      var sideDishMismatch = productMismatch.sideDishes[x]
      basketProduct.size.sideDishes.filter(function (s) {
        if (s.id === sideDishMismatch.id) {
          s.price = parseFloat(sideDishMismatch.price)
          s.pricePickup = parseFloat(sideDishMismatch.price_pickup)
          s.ignoreMinimumOrderValue = sideDishMismatch.ignoreMinimumOrderValue
          return
        }
      })
    }
    basketProduct.updateTotalPrice()
    return basketProduct
  }

  /**
   * Set payment method.
   * @param {string} id of the payment method
   */
  setPaymentMethod (id) {
    this.basket.setPaymentMethod(id)
    this.updateUI()
  }

  /**
   * Get the current payment method.
   * @return the current selected payment method.
   */
  getPaymentMethod () {
    return this.basket.paymentMethod
  }

  addVoucher (voucherObj) {
    this.basket.addVoucher(voucherObj)
    this.updateUI()
  }

  removeVoucher () {
    this.updateUI()
  }

  /**
   * Retrieve the product data from object literal.
   * @return Product
   */
  getProduct (id) {
    for (let x in this.products) {
      var dataProduct = this.products[x]
      if (dataProduct.productId === id && dataProduct.categoryId !== '0') {
        var product = new Product()
        product.id = dataProduct.productId
        product.productName = dataProduct.name
        product.count = this.getProductCount(dataProduct)
        product.basePrice = dataProduct.price
        product.basePricePickup = dataProduct.price_pickup
        product.categoryId = dataProduct.categoryId
        product.deliveryType = dataProduct.deliverymethod
        product.ignoreMinimumOrderValue = !dataProduct.is_meal

        if (dataProduct.hasSizes) {
          if (dataProduct.sizes === undefined) {
            return null
          }

          for (let xx in dataProduct.sizes) {
            var dataSize = dataProduct.sizes[xx]
            if (dataSize.isSelected) {
              var size = new ProductSize()
              size.id = dataSize.id
              size.sizeName = dataSize.name
              size.price = dataSize.price
              size.pricePickup = dataSize.price_pickup
              size.sideDishes = []
              size.deliveryType = parseInt(dataSize.deliverytype)
              size.ignoreMinimumOrderValue = !dataSize.is_meal
              for (let xxx in dataSize.sidedishgroups) {
                var dataGroup = dataSize.sidedishgroups[xxx]
                for (let xxxx in dataGroup.sidedishes) {
                  var dataSidedish = dataGroup.sidedishes[xxxx]
                  if (dataSidedish.isSelected) {
                    var sideDish = new SideDish()
                    sideDish.id = dataSidedish.id
                    sideDish.sideDishName = dataSidedish.name
                    sideDish.price = dataSidedish.price
                    sideDish.pricePickup = dataSidedish.price_pickup
                    sideDish.ignoreMinimumOrderValue = !dataSidedish.is_meal
                    size.sideDishes.push(sideDish)
                  }
                }
              }
              product.size = size
              break
            }
          }
        }
        return product
      }
    }
    return null
  }

  getProductCount (product) {
    if (!product.hasSizes) {
      return 1
    }

    var count = 1
    for (let x in product.sizes) {
      var size = product.sizes[x]
      if (size.isSelected) {
        count = jQuery('#iproductnumber' + size.id).attr('value')
        break
      }
    }
    if (count !== undefined) {
      return parseInt(count)
    }
    return count
  }

  /**
   * Update basket UI
   */
  updateUI () {
    console.log('%c BasketController(): updateUI() ', 'background: #005000; color: #ff')
    this.updateBasketUtilityBar()
    this.updateBasketUI()
    this.updateBasketMissingUI()
    this.updatePaymentUI()
    this.updateVoucherUI()
  }

  /**
   * Update the UI of the utility bar
   */
  updateBasketUtilityBar () {
    jQuery('#btn-basket span.btn-cart-price')[0].innerHTML = Utils.formatPrice(this.basket.totalPrice, this.restaurant.currency)
    var productCount = this.basket.totalProducts
    jQuery('.btn-cart-amount')[0].innerHTML = productCount
    if (productCount > 0) {
      jQuery('#btn-basket').addClass('btn-basket-products')
    } else {
      jQuery('#btn-basket').removeClass('btn-basket-products')
    }

    if (productCount === 0) {
      return
    }

    jQuery('#btn-basket').find('.btn-cart-icon').addClass('pulse-button')

    setTimeout(function () {
      jQuery('#btn-basket').find('.btn-cart-icon').removeClass('pulse-button')
    }, 250)

    if (!jQuery('.subnav-wrapper').hasClass('basketmode')) {
      jQuery('#btn-basket').addClass('highlight')
      setTimeout(function () {
        jQuery('#btn-basket').removeClass('highlight')
      }, 1000)
    }
  }

  generateSideDishString (sideDishes) {
    var stringBuilder = []
    for (let x in sideDishes) {
      var sideDish = sideDishes[x]

      var paranthesesMatches = sideDish.sideDishName.match(/(\(.*?\))/g) // remove sidedish price string
      var nameFixed = sideDish.sideDishName
      if (paranthesesMatches && paranthesesMatches.length > 0) {
        nameFixed = sideDish.sideDishName.replace(paranthesesMatches[paranthesesMatches.length - 1], '')
      }
      nameFixed = nameFixed.replace(/(^\s+|\s+$)/g, '')
      if (this.basket.deliveryType == ENUM.DeliveryMethod.Type.Delivery && sideDish.ignoreMinimumOrderValue) {
        nameFixed = '<span class=\'cart-meal-exclude\' title=\'' + this.restaurant.translations.minimumExclusionProducts + '\'>' + nameFixed + '</span>'
      }
      stringBuilder.push(nameFixed)
    }
    return stringBuilder.join(', ')
  }

  /**
   * Update the UI of the basket menu.
   * So bad using jQuery
   */
  updateBasketUI () {
    // Reset the UI of the basket and page.
    jQuery('.missing .missing_products').text('')
    jQuery('.missing').hide()
    jQuery('.mismatch').hide()
    jQuery('#products').empty()
    jQuery('#js-basket-container #discounts').empty()
    jQuery('#autoaddproducts').empty()
    jQuery('#voucher').empty().hide()
    jQuery('#js-basket-container #sum').empty().hide()
    jQuery('#cart-exclusive').hide()
    jQuery('#cart-exclusive-only').hide()
    jQuery('#empty').show()
    jQuery('#js-basket-container .minimumorderamount-reached').hide()
    jQuery('#js-basket-container .cartbutton-button').addClass('btn-disabled')
    jQuery('#js-basket-container .cartbutton-button').attr('href', '#')
    jQuery('#js-basket-container .cartbutton-button').click(function () {
      return false
    })
    jQuery('.meal-error-mismatch').hide()
    jQuery('.meal-error-missing').hide()

    if (this.basket.totalProducts === 0) {
      return
    }

    jQuery('#empty').hide()

    // Products, side dishes and comments
    for (let x in this.basket.basketProducts) {
      var basketProduct = this.basket.basketProducts[x]
      if (basketProduct.isDisabled) {
        continue
      }

      /**
       * isXFM
       */
      const isXFM = this.basket.deliveryType === ENUM.DeliveryMethod.Type.Delivery && basketProduct.ignoreMinimumOrderValue

      /**
       * Side dishes
       */
      let sideDishesTemplate = ''

      if (basketProduct.size !== null) {
        let sideDishesUI = []
        if (basketProduct.productName !== basketProduct.size.sizeName) {
          sideDishesUI.push(basketProduct.size.sizeName)
        }

        if (basketProduct.size.sideDishes.length > 0) {
          sideDishesUI.push(this.generateSideDishString(basketProduct.size.sideDishes))
        }

        sideDishesTemplate = `
          <div class="cart-row">
            <span class="cart-meal-extra grey">${sideDishesUI.join(', ')}</span>
          </div>`
      }

      /**
       * Comments
       */
      const hasComment = basketProduct.comment !== null && basketProduct.comment !== ''

      const commentTemplate = hasComment
        ? `
        <div class="cart-row">
          <span class="cart-meal-comment grey">${basketProduct.comment}</span>
        </div>`
        : ``

      const commentButtonsTemplate = hasComment
        ? `
            <a class="cart-meal-btn delete"
               onclick="basket.deleteProductComment(event, '${basketProduct.uniqueId}'); return false;">
                ${this.restaurant.translations.REMARK_DELETE}
            </a>
            <a class="cart-meal-btn edit"
               onclick="basket.closeProductComment(event, '${basketProduct.uniqueId}', true); return false;">
                ${this.restaurant.translations.REMARK_EDIT}
            </a>`
        : `
            <a class="cart-meal-btn cancel"
               onclick="basket.closeProductComment(event, '${basketProduct.uniqueId}', false); return false;">
                ${this.restaurant.translations.REMARK_CANCEL}
            </a>
            <a class="cart-meal-btn add"
               onclick="basket.closeProductComment(event, '${basketProduct.uniqueId}', true); return false;">
                ${this.restaurant.translations.REMARK_ADD}
            </a>`

      const commentTextareaTemplate = `
        <div
             class="cart-row commentinput"
             id="commentinput-${basketProduct.uniqueId}"
             style="${hasComment ? `` : `display:none`}"
        >
          <fieldset>
            <legend>${this.restaurant.translations.REMARK_BOX_TITLE}</legend>
            <textarea
                class="cart-meal-textarea"
                placeholder="${this.restaurant.translations.REMARK_EXAMPLE}"
                cols="0"
                rows="4"
                maxlength="160"
                onkeyup="basket.addProductComment(event, '${basketProduct.uniqueId}', true); return false;"></textarea>
          </fieldset>
          <div class="cart-meal-btns">
            ${commentButtonsTemplate}
          </div>
        </div>`

      let ageRestrictions = ''
      let productRestrictedAge = this.basket.ageRestrictionValue(basketProduct.uniqueId)
      if (productRestrictedAge !== null && productRestrictedAge > 0) {
        ageRestrictions = `<span class="age-restriction">+${productRestrictedAge}</span>`
      }

      /**
       * Product
       */
      const productTemplate = `
        <div class="cart-single-meal">
          <div class="cart-row" data-restaurant="<?php echo $StaticBasket->RestaurantIdEncrypted; ?>">
            <span class="cart-meal-amount">${basketProduct.count}x</span>
            <span class="cart-meal-name">${basketProduct.productName}</span>
            ${ageRestrictions}
            <div class="cart-meal-edit-buttons">
              <div class="cart-meal-edit-delete"
                   onclick="basket.decreaseProduct(event, '${basketProduct.uniqueId}')"></div>
              <div class="cart-meal-edit-add"
                   onclick="basket.increaseProduct(event, '${basketProduct.uniqueId}')"></div>
              <div class="cart-meal-edit-comment"
                   onclick="basket.openProductComment(event, '${basketProduct.uniqueId}')"></div>
            </div>
            <span
                  class="cart-meal-price ${isXFM ? `cart-meal-exclude` : ``}"
                  ${isXFM ? `title="${this.restaurant.translations.minimumExclusionProducts}"` : ``}
            >
              ${Utils.formatPrice(basketProduct.getTotalPrice(this.basket.deliveryType), this.restaurant.currency)}
            </span>
            <span class="cart-meal-delete"
                  onclick="basket.removeProduct(event, '${basketProduct.uniqueId}')"></span>
          </div>
          ${sideDishesTemplate}
          ${commentTemplate}
          ${commentTextareaTemplate}
        </div>`

      document.querySelector('#js-basket-container #products').insertAdjacentHTML('beforeend', productTemplate)
    }

    // Open the selected product comment when it was opened
    if (this.selectedProductCommentId !== null) {
      this.openProductComment(event, this.selectedProductCommentId, true)
    }

    // Discounts
    for (let x in this.basket.activeDiscounts) {
      let discount = this.basket.activeDiscounts[x]
      if (discount.totalPrice === 0) {
        continue
      }

      let productNames = discount.productNames.length > 0
        ? ' (' + discount.productNames.join(' + ') + ')'
        : ''

      let discountTemplate = `
        <div class="cart-single-meal">
          <div class="cart-row">
            <span class="cart-meal-amount">${discount.count + 'x'}</span>
            <span class="cart-meal-name">${discount.discountName + productNames}</span>
            <span class="cart-meal-price">-${Utils.formatPrice(discount.totalPrice, this.restaurant.currency)}</span>
            <span class="cart-meal-delete cart-meal-delete-disabled"></span>
          </div>
        </div>`

      document.querySelector('#js-basket-container #discounts').insertAdjacentHTML('beforeend', discountTemplate)
    }

    // Auto add products
    for (let x in this.basket.autoAddProducts) {
      const autoAddProduct = this.basket.autoAddProducts[x]

      const autoAddProductTemplate = `
        <div class="cart-single-meal">
          <div class="cart-row">
            <span class="cart-meal-amount">${autoAddProduct.count}x</span>
            <span class="cart-meal-name">${autoAddProduct.productName}</span>
            <span class="cart-meal-price">${Utils.formatPrice(autoAddProduct.getTotalPrice(this.basket.deliveryType), this.restaurant.currency)}</span>
            <span class="cart-meal-delete cart-meal-delete-disabled"></span>
          </div>
        </div>`

      document.querySelector('#js-basket-container #autoaddproducts').insertAdjacentHTML('beforeend', autoAddProductTemplate)
    }

    if (this.basket.basketProducts.length > 0) {
      jQuery('#js-basket-container #sum').show()

      // Subtotal price
      const subTotalPriceTemplate = `
        <div class="cart-row">
          <span class="cart-sum-name grey">${this.restaurant.translations.SUB_TOTAL_COSTS}</span>
          <span class="cart-sum-price grey">${Utils.formatPrice(this.basket.baseTotalPrice, this.restaurant.currency)}</span>
        </div>`

      document.querySelector('#js-basket-container #sum').insertAdjacentHTML('beforeend', subTotalPriceTemplate)
      // Delivery costs
      if (this.basket.deliveryType === ENUM.DeliveryMethod.Type.Delivery) {
        const price = this.basket.deliveryCosts > 0
          ? Utils.formatPrice(this.basket.deliveryCosts, this.restaurant.currency)
          : this.restaurant.translations.free

        const deliveryCostsTemplate = `
          <div class="cart-row">
            <span class="cart-sum-name grey">${this.restaurant.translations.DELIVERY_COSTS}</span>
            <span class="cart-sum-price grey">${price}</span>
          </div>`

        document.querySelector('#js-basket-container #sum').insertAdjacentHTML('beforeend', deliveryCostsTemplate)
      }

      // Voucher
      if (
        this.basket.voucher !== null &&
        this.basket.voucherValidation.productRequired &&
        this.basket.voucherValidation.minimumAmount
      ) {
        const voucherTemplate = `
          <div class="cart-row">
            <span class="cart-sum-name row-green">${this.restaurant.translations.VOUCHER}</span>
            <span class="cart-sum-price row-green">-${Utils.formatPrice(this.basket.voucher.discount, this.restaurant.currency)}</span>
          </div>`

        document.querySelector('#js-basket-container #sum').insertAdjacentHTML('beforeend', voucherTemplate)
      }

      // Transaction costs
      if (this.basket.transactionCosts !== 0 && this.basket.transactionCosts !== undefined) {
        const transactionCostsTemplate = `
          <div class="cart-row">
            <span class="cart-sum-name row-green">${this.restaurant.translations.transactionCosts} (${this.basket.paymentMethod.name})</span>
            <span class="cart-sum-price row-green">${Utils.formatPrice(this.basket.transactionCosts, this.restaurant.currency)}</span>
          </div>`

        document.querySelector('#js-basket-container #sum').insertAdjacentHTML('beforeend', transactionCostsTemplate)
      }

      // Total Price
      const totalPriceTemplate = `
        <div class="cart-row row-sum">
          <span class="cart-sum-name">${this.restaurant.translations.TOTAL_COSTS}</span>
          <span class="cart-sum-price">${Utils.formatPrice(this.basket.totalPrice, this.restaurant.currency)}</span>
        </div>`

      document.querySelector('#js-basket-container #sum').insertAdjacentHTML('beforeend', totalPriceTemplate)

      // Free delivery costs from
      if (this.basket.deliveryCosts > 0 && this.basket.deliveryArea.noDeliveryCostsFrom > 0) {
        const noDeliveryCostsFrom = Utils.formatPrice(this.basket.deliveryArea.noDeliveryCostsFrom, this.restaurant.currency)
        const text = this.restaurant.translations.FREE_DELIVERY_FROM.replace('{costs}', noDeliveryCostsFrom)

        const freeDeliveryFromTemplate = `
          <div class="cart-row">
            <span class="cart-sum-name">${text}</span>
          </div>`

        document.querySelector('#js-basket-container #sum').insertAdjacentHTML('beforeend', freeDeliveryFromTemplate)
      }
    }

    if (this.basket.deliveryType === ENUM.DeliveryMethod.Type.Delivery) {
      if (this.basket.isCheckoutAllowed) {
        jQuery('.cartbutton-button').removeClass('btn-disabled')
        DOM.html($('#js-basket-container .minimumorderamount-reached'), this.restaurant.translations.minimumReached)
      }

      if (this.basket.deliveryArea !== undefined) {
        // MOV only
        if (this.basket.getTotalProductsMOVOnly() === 0) {
          jQuery('#cart-exclusive-only').css('display', 'flex')
        }

        // Minimum order amount
        const requirement = this.basket.calculateMinimumAmount(this.basket.minimumOrderValueTotalPrice)

        let movText
        if (requirement > 0) {
          movText = this.restaurant.translations.minimumNotReached.replace('{restaurant}', this.restaurant.name)
          movText = movText.replace('{costs}', Utils.formatPrice(this.basket.deliveryArea.minimumOrderAmount, this.restaurant.currency))
        } else {
          movText = this.restaurant.translations.minimumReached.replace('{costs}', Utils.formatPrice(this.basket.deliveryArea.minimumOrderAmount, this.restaurant.currency))
        }

        if (this.basket.hasMinimumAmount() && this.basket.getTotalProductsMOVOnly() > 0) {
          DOM.html($('#js-basket-container .minimumorderamount-reached'), movText)
          jQuery('#js-basket-container .minimumorderamount-reached').show()
        }

        // =========================================
        if (requirement > 0) {
          const minimumOrderTemplate = `
            <div class="cart-row">
              <span class="cart-sum-name row-green">${this.restaurant.translations.REACH_MINIMUM_ORDER_AMOUNT}</span>
              <span class="cart-sum-price row-green">${Utils.formatPrice(requirement, this.restaurant.currency)}</span>
            </div>`

          document.querySelector('#js-basket-container #sum').insertAdjacentHTML('beforeend', minimumOrderTemplate)
        }
      }
    } else if (this.basket.isCheckoutAllowed) {
      jQuery('.cartbutton-button').removeClass('btn-disabled')
    }

    if (this.basket.containsExcludeProduct()) {
      jQuery('#cart-exclusive').show()
    }
  }

  updateBasketMissingUI () {
    if (this.page !== ENUM.PAGE.CHECKOUT) {
      return
    }

    for (let x in this.basket.productMismatches) {
      var productMismatch = this.basket.productMismatches[x]
      jQuery('#' + productMismatch.uniqueId).closest('.cart-single-meal').addClass('highlight')
    }

    for (let x in this.basket.productMissings) {
      var productMissing = this.basket.productMissings[x]

      var sb = new Utils.StringBuilder()
      sb.append('<strong>')
        .append(productMissing.productName)
        .append('</strong>')
        .append('<br />')

      if (productMissing.size !== null) {
        var sideDishesUI = []
        if (productMissing.productName !== productMissing.size.sizeName) {
          sideDishesUI.push(productMissing.size.sizeName)
        }

        if (productMissing.size.sideDishes.length > 0) {
          sideDishesUI.push(this.generateSideDishString(productMissing.size.sideDishes))
        }
        sb.append('<i>')
          .append(sideDishesUI.join(', '))
          .append('</i>')
          .append('<br />')
      }
      sb.append('<br />')

      jQuery('.missing .missing_products').append(sb.toString())
    }

    const t = this.restaurant.translations
    if (this.basket.productMissings.length > 0) {
      // In the basket
      let text = this.basket.productMissings.length === 1
        ? t.productMissingBasketSingular
        : t.productMissingBasketPlural

      DOM.html($('.missing .cart-meal-error'), text)
      jQuery('.missing').show()

      // Show it below the order button on step 4.
      text = this.basket.productMissings.length === 1
        ? t.productMissingSingular
        : t.productMissingPlural

      DOM.html($('.meal-error-missing'), text)
      jQuery('.meal-error-missing').show()
    }

    if (this.basket.productMismatches.length > 0) {
      // In the basket
      let text = this.basket.productMismatches.length === 1
        ? t.productMismatchSingular
        : t.productMismatchPlural

      DOM.html($('.mismatch .cart-meal-error'), text)
      jQuery('.mismatch').show()

      // Show it below the order button on step 4.
      text = this.basket.productMismatches.length === 1
        ? t.productMismatchSingular
        : t.productMismatchPlural

      DOM.html($('.meal-error-mismatch'),text)
      jQuery('.meal-error-mismatch').show()
    }

    // Clear basket validation data
    this.basket.clearBasketValidationData()
  }

  /**
   * Lame. Hides the warning messages on the basket UI.
   */
  hideWarnings () {
    jQuery('#products .warning').hide()
    jQuery('#js-basket-container .basketmismatch').hide()
    jQuery('#js-basket-container .basketmissing').hide()
  }

  /**
   * Not good to put it here. The basket controller shouldn't handle the UI of the page.
   */
  updateVoucherUI () {
    if (this.basket.voucher === null) {
      jQuery('#ivouchercontainerr').show()
      jQuery('#ivouchercontainer').empty()
      jQuery('.paymentnormal').show()
      return
    }
    jQuery('#ivouchercontainerr').hide()
    var translations = this.restaurant.translations
    var voucher = this.basket.voucher
    var sb = new Utils.StringBuilder()

    if (!this.basket.voucherValidation.productRequired) {
      sb.append(translations.voucherProductError1)
        .append(' <b>')
        .append(voucher.productName)
        .append(' </b>')
        .append(translations.voucherProductError2)
        .append(' ')
        .append('<a href=\'/' + this.restaurant.url + '\'>')
        .append(translations.voucherProductError3)
        .append('</a>')
        .append(' ')
        .append(translations.voucherProductError4)
        .append('<div class="removevoucherbutton">')
        .append('<a class="button_white button_white_checkvoucher" href="#" onclick="basket.removeVoucher(); return false">')
        .append('<span>')
        .append(this.restaurant.translations.voucherRemove)
        .append('</span>')
        .append('</a>')
        .append('</div>')
        .append('</div>')

      DOM.html($('#ivouchercontainer'), sb.toString())
      return
    }

    if (!this.basket.voucherValidation.minimumAmount) {
      sb.append(translations.voucherMinimumError1)
        .append(' ')
        .append('<b>')
        .append(Utils.formatPrice(voucher.minimumOrderAmount, this.restaurant.currency))
        .append('</b> ')
        .append(translations.voucherMinimumError2)
        .append(' ')
        .append('<a href=\'/' + this.restaurant.url + '\'>')
        .append(translations.voucherMinimumError3)
        .append('</a>')
        .append(' ')
        .append(translations.voucherMinimumError4)
        .append('<div class="removevoucherbutton">')
        .append('<a class="button_white button_white_checkvoucher" href="#" onclick="basket.removeVoucher(); return false">')
        .append('<span>')
        .append(this.restaurant.translations.voucherRemove)
        .append('</span>')
        .append('</a>')
        .append('</div>')
        .append('</div>')

      DOM.html($('#ivouchercontainer'), sb.toString())
      return
    }

    switch (Number(voucher.type)) {
      case Voucher.Type.Credit:
        sb.append(translations.voucherSummary1).append(' ')
          .append('<b>').append(Utils.formatPrice(voucher.initialCredit, this.restaurant.currency)).append('</b>')
          .append(' ')
          .append(translations.voucherSummary2).append(' ')
          .append(translations.voucherSummary7).append(' ')
          .append('<b>').append(Utils.formatPrice(voucher.currentCredit, this.restaurant.currency)).append('</b>')
          .append(' ')
          .append(translations.voucherSummary8).append(' ')
        if (voucher.remainingPayment > 0) {
          sb.append(translations.voucherSummary5)
            .append(' ')
            .append('<b>').append(Utils.formatPrice(voucher.remainingPayment, this.restaurant.currency)).append('</b>')
            .append(' ')
            .append(translations.voucherSummary6)
        } else {
          sb.append(translations.voucherSummary3).append(' ')
            .append('<b>').append(Utils.formatPrice(voucher.basedOnTotalPrice, this.restaurant.currency)).append('</b>')
            .append(' ')
            .append(translations.voucherSummary4)
        }
        break
      case Voucher.Type.Discount:
        if (voucher.amount > 0) {
          sb.append(translations.voucherSummary1).append(' ')
            .append('<b>')
            .append(Utils.formatPrice(voucher.amount, this.restaurant.currency))
            .append(' ')
        } else {
          sb.append(translations.voucherSummary1).append(' ')
            .append('<b>').append(voucher.percentage, this.restaurant.currency)
            .append('% ')
        }
        sb.append('</b>')
          .append(' ')
          .append(translations.voucherSummary2).append(' ')
          .append(translations.voucherSummary3).append(' ')
          .append('<b>').append(Utils.formatPrice(voucher.discount, this.restaurant.currency)).append('</b>')
          .append(' ')
          .append(translations.voucherSummary4).append(' ')

        if (voucher.remainingPayment > 0) {
          sb.append(translations.voucherSummary5).append(' ')
            .append('<b>').append(Utils.formatPrice(voucher.remainingPayment, this.restaurant.currency)).append('</b>')
            .append(' ')
            .append(translations.voucherSummary6)
        }
        break
    }

    const message = sb.toString()
    sb.clear()
    sb.append('<div class=\'vouchersummary\'>')
      .append('<b>')
      .append(this.restaurant.translations.voucherAdded)
      .append('</b>')
      .append('<p>')
      .append(message)
      .append('</p>')
      .append('<div class="removevoucherbutton">')
      .append('<a class="button_white button_white_checkvoucher" href="#" onclick="basket.removeVoucher(); return false">')
      .append('<span>')
      .append(this.restaurant.translations.voucherRemove)
      .append('</span>')
      .append('</a>')
      .append('</div>')
      .append('</div>')

    DOM.html($('#ivouchercontainer'), sb.toString())
  }

  /**
   * Not good to put it here. The basket controller shouldn't handle the UI of the page.
   */
  updatePaymentUI () {
    if (this.page !== ENUM.PAGE.CHECKOUT) {
      return
    }

    if (this.basket.paymentMethod === null) {
      return
    }

    switch (this.basket.paymentMethod.id) {
      case PaymentMethod.ID.Cash:
        var possiblePayments = Utils.getPossibleCashPayments(this.basket.totalPrice, Utils.getDenominations(window.GeoCountryCode))
        // remove the default 'select option' option
        jQuery('#ipayswith option:gt(0)').remove()
        var $el = jQuery('#ipayswith')
        $el.empty()
        for (let x in possiblePayments) {
          var value = possiblePayments[x]
          var label = Utils.formatPrice(value, this.restaurant.currency)
          if (x === '0') {
            // send empty value so checkout.inc knows it is the exact amount being paid with
            $el.append(jQuery('<option></option>').attr('value', '').addClass('pulldown').html(this.restaurant.translations.exactCash + ': ' + label))
          } else {
            $el.append(jQuery('<option></option>').attr('value', value).addClass('pulldown').html(label))
          }
        }
        break
      default:
        break
    }

    jQuery('.paymentdetailsbox').children().hide()
    let el
    if (this.basket.paymentMethod.mainId !== undefined) {
      el = jQuery('#payment-case-' + this.basket.paymentMethod.mainId).show()
    } else {
      el = jQuery('#payment-case-' + this.basket.paymentMethod.id).show()
    }

    let payment = el.find('.var-payment-method')
    payment.text(this.basket.paymentMethod.name)
    let costs = el.find('.var-costs')
    costs.html(Utils.formatPrice(this.basket.transactionCosts, this.restaurant.currency))

    if (this.basket.transactionCosts > 0) {
      jQuery('.transaction-cost-holder').show()
    } else {
      jQuery('.transaction-cost-holder').hide()
    }

    // pickup should hide delivery only methods.
    if (this.basket.deliveryType === ENUM.DeliveryMethod.Type.Delivery) {
      if (!this.isVoucherActive()) {
        jQuery('.paymentmethod-delivery-only').show()
      }
    } else {
      if (!this.isVoucherActive()) {
        jQuery('.paymentmethod-delivery-only').hide()
      }
    }
  }

  // Checkout page

  isVoucherActive () {
    if (this.basket.voucher !== null) {
      if (this.basket.totalPrice === 0) {
        this.hideAllPaymentMethods()
        jQuery('#payment-case-13').show()
      } else {
        this.hideOfflinePaymentMethods()
        this.showOnlinePaymentMethods()
      }
      return true
    } else {
      this.showAllPaymentMethods()
      return false
    }
  }

  hideAllPaymentMethods () {
    jQuery('.paymentbuttonwrapper').hide()
    jQuery('.paymentdetailnormal').hide()
    jQuery('.payment-type-online').hide()
  }

  hideOfflinePaymentMethods () {
    jQuery('.paymentdetailnormal').hide()
    jQuery('.payment-method-type-offline').hide()
  }

  showAllPaymentMethods () {
    jQuery('.paymentbuttonwrapper').show()
  }

  showOnlinePaymentMethods () {
    jQuery('.payment-method-type-online').show()
  }

  selectFirstPossiblePaymentMethod () {
    console.log('selectFirstPossiblePaymentMethod() init')
    // get first possible paymentmethod
    // then, select proper elements on checkout page for visual
    var paymentId = this.restaurant.paymentMethods[0].id

    jQuery('.paymentbuttonwrapper', '#ipaymentmethods').each(function (index, el) {
      $(this).removeClass('paymentbuttonchecked')
      if (index === 0) {
        $(this).addClass('paymentbuttonchecked').find('input').prop('checked', true)
      }
    })

    jQuery('#iselectpayment').val(paymentId)
    this.setPaymentMethod(paymentId)
  }

  selectPaymentMethodById (id) {
    jQuery('.paymentbuttonwrapper', '#ipaymentmethods').each(function (index, el) {
      $(this).removeClass('paymentbuttonchecked')
      if (id === $(el).find('input').val()) {
        $(this).addClass('paymentbuttonchecked').find('input').prop('checked', true)
      }
    })

    jQuery('#iselectpayment').val(id)
    this.setPaymentMethod(id)
  }
}
